import { httpGet } from '../../utils/httpClient';
import { PopularDirections } from '../../components/LandingPage/PopularDirections/PopularDirections';
import { withLayout } from '../../Layout/Layout';
import ScrollableContent from '../../components/ScrollableContent/ScrollableContent';
import styles from '../../components/LandingPage/LandingPage.module.scss';
import React from 'react';
export const getServerSideProps = async ({
  query: { routesPage = 0, directionsPage = 0 },
}) => {
  const popularDirectionsRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=premium-economy-class&directionsOnly=true&page=${directionsPage}&size=18`
  );
  const popularRoutesRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=premium-economy-class&routesOnly=true&page=${routesPage}&size=18`
  );

  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation`
  );
  const recommendation = await recommendationRes.json();
  if (popularDirectionsRes.status >= 400) {
    return {
      notFound: true,
    };
  }
  const popularDirections = await popularDirectionsRes.json();
  const popularRoutes = await popularRoutesRes.json();
  const totalRoutesPages = popularRoutes.totalPages;
  const totalDirectionsPages = popularDirections.totalPages;

  return {
    props: {
      popularDirections,
      popularRoutes,
      recommendation,
      totalRoutesPages,
      totalDirectionsPages,
      routesPage,
      directionsPage,
    },
  };
};

function Flights({
  popularDirections,
  popularRoutes,
  routesPage,
  directionsPage,
  recommendation,
  totalRoutesPages,
  totalDirectionsPages,
  authCompleted,
}) {
  const seoHtml = (
    <div className={'container mt-4 lg:pl-4 px-4 lg:pr-0'}>
      <h2 className={'text-left'}>Book Cheap Premium Economy Flights</h2>
      <p>
        When it comes to air travel, everyone desires a comfortable and
        enjoyable experience. If you&apos;re looking for a balance between
        affordability and luxury, premium economy flights are the perfect
        choice. At First-Class.com, we bring you a curated selection of
        premium economy flights that offer enhanced comfort, exclusive
        amenities, and exceptional value. Whether you&apos;re planning a
        business trip or a leisurely escape, our comprehensive range of premium
        economy options will cater to your needs. Let&apos;s explore the world
        of premium economy travel and discover the best deals and offers
        available.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>What are Premium Economy Flights?</h2>
      </p>
      <p>
        Premium economy flights occupy a middle ground between economy and
        business class, offering travellers a more comfortable and upgraded
        experience. With extra legroom, wider seats, and increased recline,
        premium economy cabins provide enhanced comfort during your journey.
        Compared to economy class, premium economy offers additional amenities
        such as priority check-in, extra baggage allowance, and improved
        in-flight services. While it may not match the luxury of business class,
        premium economy delivers an elevated travel experience at a more
        affordable price point.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Enjoy the Luxuries of Premium Economy Travel
        </h2>
      </p>
      <p>
        Premium economy flights are designed to ensure a relaxed and pleasant
        journey from start to finish. The spacious seating arrangements allow
        you to stretch out and enjoy ample legroom, making long-haul flights
        more comfortable. You&apos;ll also have access to priority check-in
        counters, allowing you to breeze through the airport hassle-free.
        Boarding and baggage handling are expedited, ensuring a smooth travel
        experience.
        <p>&nbsp;</p>
        Indulge in a delightful culinary experience with premium economy
        flights. Enjoy specially curated menus featuring a range of gourmet
        dishes, complemented by a selection of complimentary beverages. Treat
        yourself to a glass of champagne or your favorite cocktail, enhancing
        the overall experience.
        <p>&nbsp;</p>
        In-flight entertainment takes on a new level with premium economy. Enjoy
        an immersive journey with larger seatback screens, noise-canceling
        headphones, and an extensive library of movies, TV shows, and music.
        Stay connected with onboard Wi-Fi and power outlets, allowing you to
        catch up on work or stay connected with friends and family.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Choosing the Right Premium Economy Flight
        </h2>
      </p>
      <p>
        Numerous airlines now offer premium economy cabins, each with its own
        unique features and services. From renowned international carriers to
        budget-friendly airlines, you have a wide range of options to choose
        from.
        <p>&nbsp;</p>
        To find the best premium economy flight deals, utilize our advanced
        search tools and filters. Simply enter your travel details, and our
        user-friendly platform will provide you with a comprehensive list of
        options. Compare prices, flight routes, and available services to make
        an informed decision.
        <p>&nbsp;</p>
        If you&apos;re looking for cheap premium economy flights to anywhere in
        the world, we have you covered. Our extensive network of airline
        partners allows us to offer competitive prices and exclusive deals. Book
        your tickets in advance or take advantage of last-minute offers to
        secure the best fares.
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Making the Most of Your Premium Economy Experience
        </h2>
      </p>
      <p>
        To make your premium economy journey even more enjoyable, here are some
        tips and suggestions:
        <ul>
          <li>
            Pack smartly: Since you&apos;ll have extra baggage allowance, take
            advantage of it to bring along items that enhance your comfort
            during the flight. Pack a neck pillow, eye mask, and comfortable
            clothing.
          </li>
          <li>
            Access airport lounges: Some premium economy tickets provide access
            to airport lounges. Arrive early and take advantage of the
            comfortable seating, complimentary snacks, and beverages before your
            flight.
          </li>
          <li>
            Stay hydrated: Air travel can be dehydrating, so make sure to drink
            plenty of water during the flight. Avoid excessive alcohol or
            caffeine consumption, as they can further contribute to dehydration.
          </li>
          <li>
            Stay active: Take regular walks and stretch your legs during long
            flights to prevent stiffness and discomfort.
          </li>
        </ul>
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          Find the Best Premium Economy Airfares at First-Class.com
        </h2>
      </p>
      <p>
        Experience the ultimate blend of comfort, affordability, and luxury with
        premium economy airfares. At First-Class.com, we are committed to
        providing you with the best options for premium economy travel. Book
        your tickets today and elevate your air travel experience to new
        heights. Embark on your journey with peace of mind, knowing that
        you&apos;ve secured the best deals and are well on your way to a
        remarkable travel experience.{' '}
      </p>
      <p>&nbsp;</p>
      <p>
        <h2 className={'text-left'}>
          What is the difference between economy and premium economy?
        </h2>
      </p>
      <p>
        The{' '}
        <a
          style={{ color: '#202020', textDecoration: 'underline' }}
          href="/airlines/articles/premium-economy-vs-economy"
        >
          difference between economy and premium economy
        </a>{' '}
        lies in the level of comfort, amenities, and services provided. Premium
        economy offers a significant upgrade from standard economy, providing
        passengers with more spacious seating, additional legroom, and enhanced
        recline. Premium economy passengers also enjoy priority boarding,
        dedicated cabin crew, and an improved dining experience with a selection
        of premium meals and beverages. In terms of entertainment, premium
        economy often includes larger personal screens and noise-canceling
        headphones. Overall, premium economy bridges the gap between economy and
        business class, offering a more comfortable and enjoyable flying
        experience.
      </p>
      <p>&nbsp;</p>
      {+directionsPage === 0 && +routesPage === 0 && (
        <div className={'mt-4'}>
          <ScrollableContent
            heading={
              <h3>How do premium economy flights compare to business class?</h3>
            }
            content={
              <p>
                While both premium economy and business class offer enhanced
                comfort compared to economy, there are notable differences
                between the two. Business class provides the highest level of
                luxury and exclusivity, featuring lie-flat beds, private cabins,
                gourmet meals, and access to premium airport lounges.
                Additionally, business class passengers enjoy priority services
                such as dedicated check-in counters, expedited security
                screening, and extra baggage allowance. Premium economy, on the
                other hand, offers a more affordable upgrade with increased
                legroom, wider seats, and improved amenities. While it may not
                provide the same level of luxury as business class, premium
                economy still offers a significantly enhanced experience
                compared to standard economy.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={
              <h3>Which airlines offer the best premium economy experience?</h3>
            }
            content={
              <p>
                Several airlines excel in providing the best premium economy
                experience. Among them, top contenders include Singapore
                Airlines, Cathay Pacific, Qantas Airways, Virgin Atlantic, and
                British Airways. These airlines are renowned for their spacious
                premium economy cabins, comfortable seating, exceptional
                service, and a wide range of amenities. Each airline offers its
                unique features, such as enhanced entertainment systems, premium
                meal options, and priority services. The best airline for a
                premium economy experience may vary depending on personal
                preferences, destination, and availability, so it&apos;s worth
                considering individual airline reviews and offerings when making
                a decision.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={<h3>Is it worth upgrading to premium economy?</h3>}
            content={
              <p>
                Upgrading to premium economy is often worth considering,
                especially for travellers seeking additional comfort and
                amenities without the higher cost of business class. Premium
                economy offers a noticeable improvement over standard economy,
                providing more legroom, wider seats, and enhanced services.
                Passengers can enjoy a more relaxed and comfortable journey,
                which is particularly beneficial for long-haul flights.
                Additionally, premium economy often includes priority boarding,
                upgraded dining options, and improved entertainment systems. The
                decision to upgrade ultimately depends on personal preferences,
                travel duration, budget, and the specific offerings of the
                airline. It&apos;s advisable to compare prices, evaluate the
                additional benefits, and consider the overall value for your
                individual travel needs.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={<h3>How to find affordable premium economy flights?</h3>}
            content={
              <p>
                Discover incredible deals on premium economy flights by booking
                through First-Class.com! Experience the ultimate comfort while
                jetting off to your dream holiday destination, all without
                breaking the bank.
                <p>&nbsp;</p>
                At First-Class.com, we understand the importance of
                budget-friendly travel. That&apos;s why we offer cheap premium
                economy flights, allowing you to indulge in extra comfort and
                luxury on your journey. Enjoy benefits like generous legroom,
                spacious seats, priority boarding, and upgraded in-flight
                services, all at a fraction of the cost of business class.
                <p>&nbsp;</p>
                To find affordable premium economy flights, simply use our
                advanced search tools and filters. Enter your travel details,
                and our user-friendly platform will provide you with a
                comprehensive list of options. Compare prices, flight routes,
                and available services to make an informed decision.
                <p>&nbsp;</p>
                Whether you&apos;re planning a business trip or a well-deserved
                vacation, First-Class.com is your go-to source for affordable
                premium economy flights. Start your journey in comfort and style
                without exceeding your budget. Book now and elevate your travel
                experience!
              </p>
            }
            style={styles.scrollableContentSub}
          />
        </div>
      )}
    </div>
  );
  return (
    <>
      <PopularDirections
        popularDirections={popularDirections}
        recommendation={recommendation}
        popularRoutes={popularRoutes}
        routesPage={routesPage}
        directionsPage={directionsPage}
        totalRoutesPages={totalRoutesPages}
        totalDirectionsPages={totalDirectionsPages}
        cabinClass={'premium-economy-class'}
        topImage={'/images/premium-economy-class.jpg'}
        authCompleted={authCompleted}
        seoHTML={seoHtml}
      />
    </>
  );
}

export default withLayout(Flights, false);
